import { render, staticRenderFns } from "./update-status.vue?vue&type=template&id=c42290a6&scoped=true"
import script from "./update-status.vue?vue&type=script&lang=js"
export * from "./update-status.vue?vue&type=script&lang=js"
import style0 from "./update-status.vue?vue&type=style&index=0&id=c42290a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42290a6",
  null
  
)

export default component.exports